
import Vue, { VueConstructor } from "vue";

import { workspaceMembersMixin } from "@/mixins/WorkspaceMembers";

import AxSharedWith from "@/components/AxSharedWith.vue";

type Mixins = InstanceType<typeof workspaceMembersMixin>;

export default (Vue as VueConstructor<Vue & Mixins>).extend({
  components: {
    AxSharedWith,
  },

  mixins: [workspaceMembersMixin],

  props: {
    canInvite: {
      type: Boolean,
      default: false,
    },

    notStackedLength: {
      type: Number,
      default: 0,
    },

    inversed: {
      type: Boolean,
      default: false,
    },

    stackExpandable: {
      type: Boolean,
      default: true,
    },

    stackInversed: {
      type: Boolean,
      default: false,
    },

    avatarSize: {
      type: String,
      default: "24px",
    },

    stackLength: {
      type: Number,
      default: 3,
    },

    inviteOthers: {
      type: Boolean,
      default: true,
    },
  },
});
